import React from 'react';
import PropTypes from 'prop-types';
import { Statistic as AntStatistic } from 'antd';
import { useTheme } from '../../../contexts/ThemeContext';

const Statistic = ({ 
  title, 
  value,
  prefix,
  suffix,
  style,
  valueStyle,
  ...props 
}) => {
  const { theme } = useTheme();

  const statisticStyle = {
    backgroundColor: theme.white,
    textAlign: 'center',
    ...style,
  };

  const customValueStyle = {
    color: theme.primary,
    fontSize: '24px',
    fontWeight: 600,
    ...valueStyle,
  };

  const titleStyle = {
    color: theme.textSecondary,
    fontSize: '14px',
    marginBottom: '8px',
  };

  return (
    <div style={statisticStyle}>
      <AntStatistic
        title={<div style={titleStyle}>{title}</div>}
        value={value}
        prefix={prefix}
        suffix={suffix}
        valueStyle={customValueStyle}
        {...props}
      />
    </div>
  );
};

Statistic.propTypes = {
  title: PropTypes.node,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  prefix: PropTypes.node,
  suffix: PropTypes.node,
  style: PropTypes.object,
  valueStyle: PropTypes.object,
};

export default Statistic; 